import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcoSparkles = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 36,
	height: 36,
	fill: "none",
	viewBox: "0 0 36 36",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M17.099 9.44c-.19 0-.305-.127-.33-.305-.356-2.057-.33-2.12-2.501-2.514-.203-.038-.318-.14-.318-.33s.115-.305.305-.33c2.196-.419 2.17-.482 2.514-2.501.025-.19.14-.317.33-.317s.304.127.33.304c.355 2.07.33 2.146 2.513 2.514.178.025.305.14.305.33s-.114.292-.305.33c-2.183.419-2.158.483-2.513 2.514-.026.178-.14.304-.33.304m-6.158 8.962c-.279 0-.495-.19-.52-.495-.406-3.339-.546-3.44-3.974-3.973-.33-.051-.52-.229-.52-.52 0-.28.19-.47.457-.521 3.478-.648 3.63-.648 4.037-3.987a.517.517 0 0 1 .52-.495c.28 0 .483.203.508.483.445 3.415.546 3.516 4.037 3.999a.523.523 0 0 1 .457.52c0 .28-.19.47-.457.52-3.504.648-3.592.66-4.037 4.012a.5.5 0 0 1-.508.457m8.913 14.105c-.432 0-.775-.317-.851-.762-1.003-6.817-1.892-7.693-8.57-8.595-.47-.063-.787-.406-.787-.85 0-.445.33-.8.788-.85 6.69-.75 7.655-1.765 8.569-8.583.076-.457.406-.774.85-.774.432 0 .762.317.838.774.978 6.818 1.892 7.782 8.57 8.582.47.064.8.406.8.85 0 .445-.33.8-.8.851-6.69.75-7.655 1.778-8.57 8.595-.076.445-.406.762-.837.762"
	})
});
export default SvgIcoSparkles;
